import React from 'react';
import {
    Pagination,
    PaginationContent,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "@/components/ui/pagination";
import { Button } from '@/components/ui/button';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PaginationComponentProps {
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    className?: string;
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({ totalPages, currentPage, onPageChange, className }) => {
    if (totalPages <= 1) {
        return null;
    }

    const renderPageNumbers = () => {
        const pages: (number | string)[] = [];
        const pageRange = 1;

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            pages.push(1);
            if (currentPage > pageRange + 2) pages.push('...');
            for (let i = Math.max(2, currentPage - pageRange); i <= Math.min(totalPages - 1, currentPage + pageRange); i++) {
                pages.push(i);
            }
            if (currentPage < totalPages - pageRange - 1) pages.push('...');
            pages.push(totalPages);
        }

        return pages.map((page, index) => (
            <PaginationItem key={index}>
                {page === '...' ? <span className="px-3 py-1.5">...</span> : <PaginationLink href="#" onClick={() => onPageChange(page as number)} isActive={currentPage === page} className="cursor-pointer">{page}</PaginationLink>}
            </PaginationItem>
        ));
    };

    return (
        <Pagination className={cn("mt-8", className)}>
            <PaginationContent>
                <PaginationItem>
                    <Button variant="outline" size="sm" onClick={() => onPageChange(1)} disabled={currentPage === 1} className="hidden sm:flex items-center gap-1 bg-secondary"><ChevronsLeft size={16} /> Elejére</Button>
                </PaginationItem>
                <PaginationItem>
                    <PaginationPrevious
                        href="#"
                        onClick={(e) => { e.preventDefault(); onPageChange(currentPage - 1); }}
                        className={cn("bg-secondary", { "pointer-events-none opacity-50": currentPage === 1 })}
                    >Előző</PaginationPrevious>
                </PaginationItem>
                {renderPageNumbers()}
                <PaginationItem>
                    <PaginationNext
                        href="#"
                        onClick={(e) => { e.preventDefault(); onPageChange(currentPage + 1); }}
                        className={cn("bg-secondary", { "pointer-events-none opacity-50": currentPage === totalPages })}
                    >Következő</PaginationNext>
                </PaginationItem>
                <PaginationItem>
                    <Button variant="outline" size="sm" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} className="hidden sm:flex items-center gap-1 bg-secondary">Végére <ChevronsRight size={16} /></Button>
                </PaginationItem>
            </PaginationContent>
        </Pagination>
    );
};

export default PaginationComponent;